$(document).ready(function(){
    $(".accordion-dropdown-text").each(function(i) {
        $(this).attr('id', "accordion" + (i + 1));
    });

    $('.accordion-toggle').each(function(i) {
        $(this).attr('href', "#accordion" + (i + 1));
    });

    $('.accordion-toggle').on('click', function() {
        var active = $(this).next('.accordion-dropdown-text');

        active.toggleClass("border border-top-0 border-right-0 border-left-0");
    });
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/modules/accordion-collapse.js
// module id = 14
// module chunks = 0